import { ErrorPageWithDashboardCallback } from "@react/Pages/ErrorPage/ErrorPage";

 export default function config($stateProvider) {
   'ngInject';
   $stateProvider.state('errorPage', {
     url: '/error-page',
     component: ErrorPageWithDashboardCallback
   });
 }
